export default __webpack_public_path__ + "static/media/vax-track-icon.58c71236.jpg";